// extracted by mini-css-extract-plugin
export var button = "_d0-0";
export var donut = "_d0-1";
export var donutFill = "_d0-3";
export var donutTrack = "_d0-2";